import styles from "../WorkoutAdminModal.module.css";
import Badge from "./Badge";
import { getOptionLabel } from "./workoutAdminHelpers";
import {
  MUSCLE_GROUP_OPTIONS,
  EQUIPMENT_OPTIONS,
  MOVEMENT_TYPE_OPTIONS,
} from "../workoutOptions";

export default function CatalogTab({
  categories,
  selectedCategoryId,
  setSelectedCategoryId,
  resetExerciseItemEditor,
  selectedCategory,
  exerciseItemSearch,
  setExerciseItemSearch,
  categoryItems,
  filteredCategoryItems,
  startCreateExerciseItem,
  setDemoExerciseItem,
  startEditExerciseItem,
  handleDeleteExerciseItem,
  saving,
  showInactiveExercises,
  setShowInactiveExercises,
}) {
  return (
    <div className={styles.wamGrid}>
      <div className={styles.wamSidebar}>
        <div className={styles.sectionHead}>
          <div className={styles.sectionHeadLeft}>
            <div className={styles.titleLine}>
              <h3>Categorias</h3>
              <Badge tone="info">{categories.length}</Badge>
            </div>
          </div>
        </div>

        <div className={styles.wamList}>
          {categories.map((category) => (
            <button
              key={category.id}
              type="button"
              className={`${styles.wamListItem} ${
                selectedCategoryId === category.id ? styles.activeItem : ""
              }`}
              aria-pressed={selectedCategoryId === category.id}
              onClick={() => {
                setSelectedCategoryId(category.id);
                resetExerciseItemEditor();
              }}
            >
              {category.name}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.wamMain}>
        <div className={styles.sectionHead}>
          <div className={styles.sectionHeadLeft}>
            <h3>{selectedCategory?.name || "Categoria"}</h3>
            {selectedCategory && <Badge>{selectedCategory.name}</Badge>}
          </div>
        </div>

        <div className={styles.cardGlass}>
            <div className={styles.sectionHead}>
              <div className={styles.sectionHeadLeft}>
                <h4>Exercícios da categoria</h4>
                <p className={styles.sectionHint}>Lista direta para editar sem navegar por cards.</p>
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                {selectedCategoryId && (
                  <label className={styles.wamCheck} style={{ whiteSpace: "nowrap" }}>
                    <input
                      type="checkbox"
                      checked={showInactiveExercises}
                      onChange={(e) => setShowInactiveExercises(e.target.checked)}
                    />
                    <span>Mostrar inativos</span>
                  </label>
                )}
                {selectedCategoryId && categoryItems.length > 0 && (
                  <input
                    type="search"
                    className={styles.searchInput}
                    placeholder="Buscar exercício..."
                    value={exerciseItemSearch}
                    onChange={(e) => setExerciseItemSearch(e.target.value)}
                    aria-label="Buscar exercício na categoria"
                  />
                )}
                <Badge tone="soft">
                  {exerciseItemSearch
                    ? `${filteredCategoryItems.length}/${categoryItems.length}`
                    : categoryItems.length}
                </Badge>
                {selectedCategoryId && (
                  <button
                    type="button"
                    className={`${styles.wamBtn} ${styles.primary}`}
                    onClick={startCreateExerciseItem}
                  >
                    + Criar exercício
                  </button>
                )}
              </div>
            </div>

            <div className={styles.simpleList}>
              {filteredCategoryItems.map((item) => (
                <div className={styles.simpleRow} key={item.id}>
                  <div className={styles.simpleRowMain}>
                    <div className={styles.simpleRowTop}>
                      <strong>{item.name}</strong>
                      <Badge tone={item.is_active ? "success" : "muted"}>
                        {item.is_active ? "Ativo" : "Inativo"}
                      </Badge>
                    </div>

                    <div className={styles.metaRow}>
                      {item.muscle_group && (
                        <span>{getOptionLabel(MUSCLE_GROUP_OPTIONS, item.muscle_group)}</span>
                      )}
                      {item.equipment && (
                        <span>{getOptionLabel(EQUIPMENT_OPTIONS, item.equipment)}</span>
                      )}
                      {item.movement_type && (
                        <span>{getOptionLabel(MOVEMENT_TYPE_OPTIONS, item.movement_type)}</span>
                      )}
                    </div>

                    {item.notes && <p className={styles.itemNotes}>{item.notes}</p>}
                  </div>

                  <div className={styles.simpleRowActions}>
                    {item.demo_url && (
                      <button
                        type="button"
                        className={`${styles.wamBtn} ${styles.ghost}`}
                        onClick={() => setDemoExerciseItem(item)}
                      >
                        ▶ Demo
                      </button>
                    )}
                    <button
                      type="button"
                      className={`${styles.wamBtn} ${styles.ghost}`}
                      onClick={() => startEditExerciseItem(item)}
                    >
                      Editar
                    </button>
                    <button
                      type="button"
                      className={`${styles.wamBtn} ${styles.danger}`}
                      onClick={() => handleDeleteExerciseItem(item.id)}
                      disabled={saving}
                    >
                      Remover
                    </button>
                  </div>
                </div>
              ))}

              {!categoryItems.length && (
                <div className={styles.wamEmpty}>
                  {showInactiveExercises
                    ? "Nenhum exercício cadastrado nesta categoria."
                    : "Nenhum exercício ativo nesta categoria. Marque \"Mostrar inativos\" pra ver os desativados."}
                </div>
              )}
              {categoryItems.length > 0 && !filteredCategoryItems.length && (
                <div className={styles.wamEmpty}>
                  Nenhum exercício encontrado para "{exerciseItemSearch}".
                </div>
              )}
            </div>
          </div>

      </div>
    </div>
  );
}
